// src/pages/NotFound.js — friendly 404
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import theme from '../theme/theme';

const Wrap = styled.section`
  min-height: 56vh; display: flex; flex-direction: column; align-items: center; justify-content: center;
  text-align: center; padding: 5rem 1.5rem; gap: 0.6rem;
  .big { font-family: ${theme.font.display}; font-weight: 700; font-size: clamp(3rem, 12vw, 7rem); color: ${theme.color.accent}; line-height: 1; }
  h1 { font-weight: 400; font-size: 1.6rem; } p { color: ${theme.color.inkSoft}; }
  a { margin-top: 1.2rem; background: ${theme.color.accent}; color: ${theme.color.onAccent}; font-weight: 700; padding: 12px 26px; border-radius: ${theme.layout.radius}; }
`;

export default function NotFound() {
  return (
    <>
      <Navbar />
      <Wrap>
        <div className="big">404</div>
        <h1>Page not found</h1>
        <p>The page you’re looking for doesn’t exist or has moved.</p>
        <Link to="/">Back to home</Link>
      </Wrap>
      <Footer />
    </>
  );
}
